import { render } from "./index.vue?vue&type=template&id=07cf8599&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=07cf8599&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=07cf8599&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cf8599"]])

export default __exports__